import { render, staticRenderFns } from "./SkySuffix.vue?vue&type=template&id=992729ba&scoped=true"
import script from "./SkySuffix.vue?vue&type=script&lang=js"
export * from "./SkySuffix.vue?vue&type=script&lang=js"
import style0 from "./SkySuffix.vue?vue&type=style&index=0&id=992729ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992729ba",
  null
  
)

export default component.exports